import { render } from "./DownloadAppHint.vue?vue&type=template&id=c02650ba&scoped=true"
import script from "./DownloadAppHint.vue?vue&type=script&lang=js"
export * from "./DownloadAppHint.vue?vue&type=script&lang=js"

import "./DownloadAppHint.vue?vue&type=style&index=0&id=c02650ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02650ba"]])

export default __exports__